// extracted by mini-css-extract-plugin
module.exports = {"emptyContainer":"ReviewList-module--empty-container--1D7BI","iconContainer":"ReviewList-module--icon-container--3EIYb"};